export enum PersonalityStage {
    QUIZ = 0,
    MATCH = 1,
    INTERVIEW = 2,
    STORY = 3
}
